var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArowuser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 52,
    viewBox: "0 0 43 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.504 24.9784C28.3604 24.9784 33.9186 19.5641 33.9186 12.8852C33.9186 6.20631 28.3604 0.791992 21.504 0.791992C14.6476 0.791992 9.08936 6.20631 9.08936 12.8852C9.08936 19.5641 14.6476 24.9784 21.504 24.9784Z",
    stroke: "#06F3A3",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.870064 51.4298C0.829414 50.9387 0.813147 50.4477 0.813147 49.9567C0.758605 47.2768 1.25337 44.6132 2.26849 42.1218C3.28361 39.6304 4.79869 37.3612 6.72506 35.4472C8.65143 33.5331 10.9504 32.0126 13.4874 30.9745C16.0244 29.9365 18.7484 29.4019 21.5001 29.4019C24.2518 29.4019 26.9759 29.9365 29.5129 30.9745C32.0499 32.0126 34.3489 33.5331 36.2752 35.4472C38.2016 37.3612 39.7167 39.6304 40.7318 42.1218C41.7469 44.6132 42.2417 47.2768 42.1871 49.9567C42.1871 50.4715 42.1871 50.9862 42.1302 51.4931",
    stroke: "#7929FB",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9918 32.1219C19.9918 32.1219 22.065 31.6625 23 32.1219L22.374 33.0801L23.6179 48.9193L21.8049 51.9684L19.9756 48.9668L20.691 33.1277L19.9918 32.1219Z",
    fill: "#7829FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArowuser);
export default __webpack_public_path__ + "static/media/arowuser.1ec6eb2dcc1541e3ad614c3d8ba0de63.svg";
export { ForwardRef as ReactComponent };